import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../../Images/logo_final.png";
import FeedbackModal from "../Clients/Modals/Feedback/feedbackModal";
import DrawerToggleButton from "../SideDrawer/DrawerToggleButton";
import "./navBar.css";

export const NavBar = ({
  drawerClickHandler,
  GetScrollPosition,
  session,
  scrollHeight,
}) => {
  const [feedback, setFeedback] = useState(false);
  const [feedbackSubmit, setFeedbackSubmitting] = useState(false);

  return (
    <React.Fragment>
      <FeedbackModal
        show={feedback}
        onClose={() => setFeedback(false)}
        setFeedbackSubmitting={setFeedbackSubmitting}
      />
      <nav
        className="navbar fixed-top navbar-expand-lg container "
        style={{
          height: "60px",
        }}
      >
        <NavLink
          className="btn nav-link-item"
          to="/"
          style={{ border: "none", padding: "0px" }}
        >
          <img
            src={logo}
            alt="Vicus Capital"
            style={{ maxHeight: "50px", pointerEvents: "none" }}
          />
        </NavLink>
        <label
          style={{
            color: "black",
            textDecoration: "none",
            paddingRight: "10px",
            paddingLeft: "10px",
          }}
        ></label>
        <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
          <li style={{}}></li>
        </ul>

        <div className="navbar__toggle-button">
          <DrawerToggleButton click={drawerClickHandler} />
        </div>
        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
          <div
            className="navbar-brand mx-auto"
            style={{
              fontFamily: "Times New Roman, Times, serif",
              fontSize: "1.3rem",
            }}
          ></div>
          <div className="navbar-nav navbar-right">
            {session && (
              <React.Fragment>
                <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
                  <li style={{ margin: "auto" }}></li>
                  <NavLink
                    className="nav-link-item"
                    style={{
                      color: "black",
                      textDecoration: "none",
                      top: "50%",
                    }}
                    to="/clients"
                  >
                    Clients
                  </NavLink>
                  <label
                    style={{
                      color: "black",
                      textDecoration: "none",
                      paddingRight: "10px",
                      paddingLeft: "10px",
                    }}
                  ></label>
                  <li style={{ margin: "auto" }}></li>
                  <NavLink
                    className="nav-link-item"
                    style={{
                      color: "black",
                      textDecoration: "none",
                      top: "50%",
                    }}
                    to="/user"
                  >
                    Settings
                  </NavLink>
                  <label
                    style={{
                      color: "black",
                      textDecoration: "none",
                      paddingRight: "10px",
                      paddingLeft: "10px",
                    }}
                  ></label>
                  <label
                    className="nav-link-item"
                    style={{
                      color: "black",
                      textDecoration: "none",
                      top: "50%",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setFeedback(true);
                    }}
                  >
                    Feedback
                  </label>
                  {feedbackSubmit && (
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden"></span>
                    </div>
                  )}
                  <label
                    style={{
                      color: "black",
                      textDecoration: "none",
                      paddingRight: "10px",
                      paddingLeft: "10px",
                    }}
                  ></label>
                  <li style={{ margin: "auto" }}></li>
                  <li className="nav-item" style={{ margin: "auto" }}>
                    <a
                      className="nav-link-item"
                      style={{ color: "black", textDecoration: "none" }}
                      href="https://portal.vicuscapital.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Portal
                    </a>
                  </li>
                  <li style={{ margin: "auto" }}>
                    <label
                      style={{
                        color: "black",
                        textDecoration: "none",
                        paddingRight: "10px",
                        paddingLeft: "10px",
                      }}
                    ></label>
                  </li>
                  <NavLink
                    className="nav-link-item"
                    style={{
                      color: "black",
                      textDecoration: "none",
                      top: "50%",
                    }}
                    to="/logout"
                  >
                    Logout
                  </NavLink>
                </ul>
              </React.Fragment>
            )}
          </div>
        </div>
      </nav>
    </React.Fragment>
  );
};
